import React from "react";
import { IImage, IImageStylePreset } from "shared/types";
import { getImageURLWithStyle } from "shared/utils";

import { LogoContainer } from "./styles";

interface LogoProps {
  logo: IImage;
  alt: string;
}
export const Logo: React.FC<LogoProps> = ({ logo, alt }) => {
  if (getImageURLWithStyle({ ...logo, style: IImageStylePreset.logo })) {
    return (
      <LogoContainer
        src={getImageURLWithStyle({ ...logo, style: IImageStylePreset.logo })}
        alt={alt}
      />
    );
  }

  return null;
};
